/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const researchDemoContent = [
  { type: 'heading', level: 2, text: 'User research — notes rail' },
  { type: 'paragraph', text: 'Participants: 6 internal, 2 external' },
  { type: 'heading', level: 3, text: 'Findings' },
  {
    type: 'numbered',
    items: [
      'People want search directly under filters',
      '"New note" should feel like "New chat"',
      'Meeting cards need transcribe CTA visible without scrolling',
    ],
  },
  {
    type: 'paragraph',
    text: 'Next: validate with Mission Control prototype.',
  },
]
